/* eslint-disable no-useless-catch */
import { API } from "../api";
import { TPL_CITIES_URL } from "../constants/url.constant";

export const GET_TPL_CITIES = "GET_TPL_CITIES";
export const ADD_TPL_CITY = "ADD_TPL_CITY";
export const DELETE_TPL_CITY = "DELETE_TPL_CITY";
export const UPDATE_TPL_CITY = "UPDATE_TPL_CITY";

export const getTPLCities = (params = {}) => {
  return async (dispatch) => {
    try {
      const res = await API.get(TPL_CITIES_URL, {
        params
      });
      if (Object.keys(params).length) {
        dispatch({
          type: GET_TPL_CITIES,
          payload: res
        });
      }
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const addTPLCity = (data) => {
  return async (dispatch) => {
    try {
      const res = await API.post(TPL_CITIES_URL, data);
      dispatch({
        type: ADD_TPL_CITY,
        payload: data
      });
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const updateTPLCity = (id, body) => {
  return async (dispatch) => {
    try {
      await API.put(`${TPL_CITIES_URL}/${id}`, body);
      dispatch({ type: UPDATE_TPL_CITY, payload: { id, ...body } });
    } catch (error) {
      throw error;
    }
  };
};

export const removeTPLCity = (id) => {
  return async (dispatch) => {
    try {
      const res = await API.delete(`${TPL_CITIES_URL}/${id}`);
      dispatch({
        type: DELETE_TPL_CITY,
        payload: id
      });
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export default function reducer(
  state = { cityTableRows: [], totalRows: 0 },
  { type, payload }
) {
  switch (type) {
    case GET_TPL_CITIES:
      return {
        ...state,
        cityTableColumns: payload.columns,
        cityTableRows: payload.rows,
        totalRows: payload.count
      };
    case ADD_TPL_CITY:
      return {
        ...state,
        totalRows: state.totalRows + 1,
        cityTableRows: [...state.cityTableRows, { ...payload }]
      };
    case DELETE_TPL_CITY:
      return {
        ...state,
        totalRows: state.totalRows - 1,
        cityTableRows: state.cityTableRows.filter((data) => data.id !== payload)
      };
    case UPDATE_TPL_CITY:
      return {
        ...state,
        cityTableRows: state.cityTableRows.map((data) =>
          data.id === payload.id
            ? {
              ...payload
            }
            : data
        )
      };
    default:
      return state;
  }
}
